<template>
  <div class="container-fluid mt-2">
    <div class="row">
      <div class="card">
        <div class="card-header"> {{ t.user.list }}
          <a class="tag tag-danger update-all-card text-white" href="javascript:;" @click="fetchCustomers()">{{ t.custom_reseller_panel.update_user_cards}}</a>
        </div> <!-- tr -->
        <div class="card-block p-0">
          <div class="easy-autocomplete">
            <CustomerSearch usageArea="admin" list="1"></CustomerSearch>
          </div>
          <input type="hidden" id="redirect">
          <div class="table-responsive">
            <table class="table table-striped mb-0">
              <thead>
              <tr>
                <th>{{ t['transaction'] }}</th>
                <th>{{ t.name }}</th>
                <th>{{ t.casino_giro }}</th>
                <th>{{ t.giro || 'Giro'}}</th>
                <th>{{ t.total_card_balances || 'Total Card Balances'}}</th>
                <th>{{ t.remaining_limit }}</th>
                <th>{{ t.user.last_login }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="loading">
                <td colspan="4" align="center">
                  <Loading></Loading>
                </td>
              </tr>
              <template v-if="!loading">
                <tr v-if="customers.length < 1">
                  <td colspan="4" align="center">Kayıt yok</td>
                </tr>
              </template>
              <template v-if="showList" v-for="(customerx, idxx) in customers">
                <AdminTableRow :customer="customerx" :akey="idxx" v-on:result="subUser" type="admin"/>
                <AdminTableRow v-for="(customer, idx) in customerx.customers" :akey="idx" :customer="customer" className="table-success" :referrer="customerx.id" type="reseller"/>
              </template>
              </tbody>
            </table>
            <div class="fixed-table-footer">
              <paginate v-if="pagination" class="mx-3"
                        :page-count="pagination.pageCount"
                        :page-range="pagination.pageRange"
                        :force-page="pagination.current"
                        :initialPage="pagination.current"
                        :margin-pages="$root.windowWidth < 600 ? 0 : 2"
                        :click-handler="onChangePage"
                        :prev-text="t.previous"
                        :next-text="t.next"
                        :container-class="'my-1 pagination float-right mr-0 ml-1'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-item'"
                        :prev-link-class="'page-link'"
                        :next-class="'page-item'"
                        :next-link-class="'page-link'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'
import CustomerSearch from "../CustomerSearch";
import Loading from "../Loading";
import AdminTableRow from "../row/AdminTableRow";
export default {
  name: "AdminList",
  components: {Loading, CustomerSearch, Paginate, AdminTableRow},
  data() {
    return {
      showList: true,
      customers: [],
      session: session,
      pagination: null,
      t: this.$root.t,
      loading: false
    }
  },
  watch: {
    '$route.query.uid' () {
        this.fetchCustomers()
    }
  },
  mounted() {
    this.$router.push({query: {page: 1}});
    this.fetchCustomers();
  },
  methods: {
    subUser(e) {
      this.$http.get(api + 'api/v1/users', {
        params: {
          page: this.$route.query.page,
          per_page: 100,
          direction: 'desc',
          group: [3],
          uid: this.$route.query.uid,
          referrer: e.uid,
          onlySubRef: 1,
          sort: 'u.balance'
        }
      })
          .then(response => {
            this.customers[e.key].customers = response.body.result.users;

            this.$set(this.customers, e.key, this.customers[e.key]);

          }, response => {
          })
    },
    fetchCustomers() {
      this.loading = true;
      this.$http.get(api + 'api/v1/users', {
        params: {
          page: this.$route.query.page,
          per_page: 30,
          direction: 'desc',
          uid: this.$route.query.uid,
          group: [3],
        }
      })
        .then(response => {
          this.customers = response.body.result.users;
          this.pagination = null;
          this.pagination = response.body.result.pagination;
          this.total = response.body.result.total
          this.loading = false;
          this.notfound = false;
        }, response => {
          this.customers = [];
          this.loading = false;
          this.notfound = true;
        })
    },
    onChangePage(page) {
      this.pagination.current = page;
      this.$router.push({query: {page: page}});
      window.scroll(0, 0);
      this.fetchCustomers()
    },

  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/AdminList.vue